import { getFeature } from 'Cloud/Application/FeaturesEs6';
import { IS_MOBILE_BROWSER } from 'reactApp/appHelpers/configHelpers';
import { registerExperiment } from 'reactApp/appHelpers/experimentAnalytic';
import { AnalyticEventNames } from 'reactApp/appHelpers/experimentAnalytic/eventNames';

const value: 'a' | 'b' | 'c' | undefined = getFeature('skipped-payment');

if (!IS_MOBILE_BROWSER) {
    registerExperiment(
        'skipped-payment',
        value,
        [
            AnalyticEventNames.SKIPPED_PAYMENT_MODAL_7D_SHOW,
            AnalyticEventNames.SKIPPED_PAYMENT_MODAL_7D_CLICK,
            AnalyticEventNames.SKIPPED_PAYMENT_MODAL_14D_SHOW,
            AnalyticEventNames.SKIPPED_PAYMENT_MODAL_14D_CLICK,
            AnalyticEventNames.TRIAL_TARIFF_BUY,
            AnalyticEventNames.TRIAL_TARIFF_SHOW,
        ],
        {
            sendXrayArgs: {
                [AnalyticEventNames.TRIAL_TARIFF_BUY]: ({ paySource }, { eventName }) => {
                    let name = eventName;

                    if (paySource?.startsWith('trial7_in_abandoned_payment')) {
                        name = 'trial7-buy';
                    } else if (paySource?.startsWith('trial14_in_abandoned_payment')) {
                        name = 'trial14-buy';
                    }

                    return {
                        eventName: name,
                    };
                },
                [AnalyticEventNames.TRIAL_TARIFF_SHOW]: ({ paySource }, { eventName }) => {
                    let name = eventName;

                    if (paySource?.startsWith('trial7_in_abandoned_payment')) {
                        name = 'trial7-show';
                    } else if (paySource?.startsWith('trial14_in_abandoned_payment')) {
                        name = 'trial14-show';
                    }

                    return {
                        eventName: name,
                    };
                },
            },
        }
    );
}

interface SkippedPaymentTrials {
    regular: Record<string, string>;
    family: Record<string, string>;
}

export const skippedPayment = !IS_MOBILE_BROWSER && value !== 'a' ? value : undefined;
export const skippedPaymentTrials7d: SkippedPaymentTrials = getFeature('skipped-payment-trials-7d') || {};
export const skippedPaymentTrials14d: SkippedPaymentTrials = getFeature('skipped-payment-trials-14d') || {};
